module.exports = __webpack_public_path__ + "media/images/signup-background-d390f1a3f1fe4ff8d78f50ad307aa664.png";